// extracted by mini-css-extract-plugin
export var container = "blogHomepage-module--container--9e3dc";
export var header = "blogHomepage-module--header--d2c9b";
export var section = "blogHomepage-module--section--a077a";